// extracted by mini-css-extract-plugin
export default {"mainContainer":"CourtroomAiLayout_mainContainer__TOAUD","rightContainer":"CourtroomAiLayout_rightContainer__OzAUy"};